import controleAcessoRotas from './controleacesso/ControleAcessoRotas'

export default {
  path: 'admin',
  // redirect: '/admin/instituicoes',
  name: 'Admin',
  component: {
    render (c) { return c('router-view') }
  },
  children: [
    controleAcessoRotas
  ]
}



// WEBPACK FOOTER //
// ./src/modulos/admin/AdminRotas.js